import { NavLink } from 'react-router-dom'
import ListItemButton from '@mui/material/ListItemButton'
import Text from '../../Common/Text'
import styles from '../SideMenu.module.scss'
import { ISubMenuData } from '../SideMenuConfig'

interface IProps extends ISubMenuData {
  toggleSidebar?: () => void
}

const NestedNavItem = ({ link, label, icon, toggleSidebar }: IProps) => {
  return (
    <NavLink
      key={link}
      to={link}
      className={({ isActive }) => (isActive ? styles.active : '')}
      onClick={() => {
        if (toggleSidebar) {
          toggleSidebar()
        }
      }}
    >
      {({ isActive }) => (
        <ListItemButton className={styles.nestedItem} disableRipple data-cy={`menu-item-${label}`}>
          {icon && <div className={styles.nestedIcon}>{icon}</div>}
          <Text
            variant="menuItem"
            tone={isActive ? 'primary' : 'secondary'}
            casing="role"
            className={styles.nestedLabel}
          >
            {label}
          </Text>
        </ListItemButton>
      )}
    </NavLink>
  )
}

export default NestedNavItem
